module.exports = __webpack_public_path__ + "img/health.55964379.png";